import React, { useMemo} from "react";
import { nodeTypes } from "../../../utils/nodeTypes";
import { mrTypes } from "../../../utils/mrTypes";
const allNodeTypes = nodeTypes.concat(mrTypes);
export default function NodeWrapperProperty({
  node,
  nodeChange,
  dependencies
}) {
  const propertyComponent = useMemo(() => {
    const nodeComponent = allNodeTypes.find(o => o.type === node.type);
    if (nodeComponent.propertyComponent) {
      const Element=nodeComponent.propertyComponent;
      return (<Element node={node} nodeChange={nodeChange} dependencies={dependencies} />)
    }
    return <p>edit not define</p>;
  }, [node, nodeChange,dependencies]);
  return (
    <>
      {propertyComponent}
    </>
  );
}
